export default __webpack_public_path__ + "636d942cc1834cc039bfd0d8310369e1.png";